var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowFillLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.1213203,9 L10.7405693,8.38075101 C11.1401186,7.98120175 11.1334953,7.35532072 10.7433785,6.96520392 L10.0347961,6.25662149 C9.64143525,5.86326065 9.01091726,5.8677624 8.61924899,6.25943066 L5.08785779,9.79082187 C4.8876155,9.99106416 4.78939231,10.2481546 4.7903334,10.5039246 C4.79250813,10.7565752 4.89155546,11.0128758 5.08785779,11.2091781 L8.61924899,14.7405693 C9.01879825,15.1401186 9.64467928,15.1334953 10.0347961,14.7433785 L10.7433785,14.0347961 C11.1367393,13.6414352 11.1322376,13.0109173 10.7405693,12.619249 L10.1213203,12 L15.0046024,12 C15.5443356,12 16,11.5527519 16,11.0010434 L16,9.99895656 C16,9.44266033 15.5543453,9 15.0046024,9 L10.1213203,9 Z M10.5,0 C16.296,0 21,4.704 21,10.5 C21,16.296 16.296,21 10.5,21 C4.704,21 0,16.296 0,10.5 C0,4.704 4.704,0 10.5,0 Z"
})))));
export default SvgArrowFillLeft;